import React, { useState, useEffect } from 'react';
import UI from '../ui';
import Util from './Util';

const { WrappedButton, WrappedButtonType } = UI;

/**
 * "Next" button is only be present if this is the first time the user has
 * gone through this Branded Tracking setup flow.
 *
 * If this is the first time the user clicked "Save, But Don't Publish":
 *   Branded Tracking UI permanently replaces the Next button
 *   with the "Publish Now" and "Save, But Don't Publish" buttons.
 *   These buttons retain the same functionality as described in this use case.
 *
 * If this is the first time the user clicked "Publish Now":
 *   Branded Tracking UI does the above, AND ALSO permanently removes
 *   "Save, But Don't Publish" button everywhere it's currently displayed.
 *
 * @param {boolean} isNew
 * @param {boolean} isPublished
 * @param {number} activeTabIndex
 * @returns {array}
 */
const buttonsToShow = (isNew, isPublished, activeTabIndex) => {
	const buttons = {
		next: false,
		publish: false,
		save: false,
	};

	const tabsCount = Util.canUseBrandedEmails() ? 4 : 3;

	// published
	if (isPublished) {
		buttons.publish = true;
	} else if (isNew) {
		if (activeTabIndex === tabsCount - 1) {
			// not published, new and last step
			buttons.publish = true;
			buttons.save = true;
		} else {
			// not published, new and not last step
			buttons.next = true;
		}
	} else {
		// not new, not published
		buttons.publish = true;
		buttons.save = true;
	}

	return buttons;
};

const BrandedTrackingButtons = props => {
	const { activeTabIndex, isNew, isPublished, onNext, onSave, onPublish } = props;

	const [buttons, setButtons] = useState(buttonsToShow(isNew, isPublished, activeTabIndex));

	useEffect(() => {
		setButtons(buttonsToShow(isNew, isPublished, activeTabIndex));
	}, [isNew, isPublished, activeTabIndex]);

	return (
		<div className="branded-tracking-buttons">
			{buttons.next === true && (
				<WrappedButton
					label="Next"
					onClick={onNext}
					buttonType={WrappedButtonType.Primary}
					dataqa="next"
				/>
			)}
			{buttons.publish === true && (
				<WrappedButton label="Publish Now" onClick={onPublish} dataqa="publish" />
			)}
			{buttons.save === true && (
				<WrappedButton
					buttonType={WrappedButtonType.Secondary}
					label="Save, But Don't Publish"
					onClick={onSave}
					dataqa="save"
				/>
			)}
		</div>
	);
};

export default BrandedTrackingButtons;
